module.exports = __webpack_public_path__ + "static/media/C (11).361843b7.jpg";